
    const newsData = [
      {
        id: 1,
        title: "Exclusive interview with ANI Media",
        slug: "exclusive-interview-with-ani",
        excerpt: "Expanding affordable air travel across India.",
        content: `In this exclusive interview, our founder discusses the vision of making air travel accessible to every Indian. From humble beginnings to launching an airline, hear the inspiring journey and future plans for domestic expansion.`,
        image:
          "https://i.ytimg.com/vi/9jDq9uSp2zY/hq720.jpg",
        videoUrl: "https://youtu.be/9jDq9uSp2zY",
        date: "2026-01-18",
      },
      {
        id: 2,
        title: "From Tempo driver to Airline owner",
        slug: "from-tempo-driver-to-airline-owner",
        excerpt: "An inspiring story of entrepreneurship and determination.",
        content: `Starting from scratch as a tempo driver, our founder's relentless pursuit of excellence led to establishing a full-fledged airline. This remarkable transformation showcases the power of vision and hard work in the Indian business landscape.`,
        image:
          "https://i.ytimg.com/vi/YCSFLDZXp_Y/hq720.jpg",
        videoUrl: "https://youtu.be/YCSFLDZXp_Y",
        date: "2026-01-18",
      },
      {
        id: 3,
        title: "Journey behind launching new routes",
        slug: "journey-behind-launching-new-routes",
        excerpt: "Behind-the-scenes look at route planning and operations.",
        content: `Discover the strategic planning and meticulous execution involved in launching new domestic routes. Learn how market research and customer feedback shaped our expansion strategy to connect tier-2 and tier-3 cities.`,
        image:
          "https://i.ytimg.com/vi/shSIsGNegDQ/hq720.jpg",
        videoUrl: "https://youtu.be/shSIsGNegDQ",
        date: "2026-01-18",
      },
      {
        id: 4,
        title: "Shorts: Inside airline operations of Shankh Air",
        slug: "shorts-inside-airline-operations",
        excerpt: "Quick insights into daily operations and crew training.",
        content: `Get a glimpse into the daily operations of Shankh Air, from aircraft maintenance to crew training programs. These short clips showcase the professionalism and dedication of our team members.`,
        image:
          "https://i.ytimg.com/vi/E0UETS1BAys/hq720.jpg",
        videoUrl: "https://youtube.com/shorts/E0UETS1BAys",
        date: "2026-01-18",
      },
      {
        id: 5,
        title: "How affordable flying is changing India",
        slug: "how-affordable-flying-is-changing-india",
        excerpt: "Impact of budget airlines on Indian travel and economy.",
        content: `Affordable air travel is democratizing mobility across India. Explore how competitive pricing and quality service are encouraging millions to fly for the first time, boosting tourism and business growth across regions.`,
        image:
          "https://i.ytimg.com/vi/WkP2BlyQV1A/hq720.jpg",
        videoUrl: "https://youtu.be/WkP2BlyQV1A",
        date: "Jan-2026",
      },
      {
        id: 6,
        title: "Meet the team behind the Shankh Air",
        slug: "meet-the-team-behind-the-airline",
        excerpt: "Profiles of the talented individuals driving our mission.",
        content: `Meet the diverse team of professionals who make Shankh Air possible. From pilots and engineers to customer service representatives, each member is committed to delivering exceptional service and safety to our passengers.`,
        image:
          "https://i.ytimg.com/vi/VCeSnEEviNw/hq720.jpg",
        videoUrl: "https://youtu.be/VCeSnEEviNw",
        date: "Jan-2026",
      },
    ];


export default newsData;
